import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerrh';
import Holerites from '../../../components/rh/holerites/editar';


function EditHoleritesScreen () {
    return (
        <Fragment>
            <Head titulo="Edição de Holerites | Consórcio LVF" />
            <Header />
            <Holerites />
            <Footer />
        </Fragment>
    );
}

export default EditHoleritesScreen;